export const BLOBS_BASE_URL = 'https://hcfloviofhvrwejr.public.blob.vercel-storage.com' || '';

export const ENABLE_BITE_PAGE_FLIP_NEXT_OUT = false;
